import React, { useState, useEffect } from 'react';
import Axios from 'axios';
import { v4 as uuid } from 'uuid';
import { Form, FormGroup, Button, Input, Label, FormFeedback } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import { toast } from 'react-toastify';

import TextFieldGroup from '../../Common/TextFieldGroup';
import SelectFieldGroup from '../../Common/SelectFieldGroup';
import ProgressIndicator from '../../Common/ProgressIndicator';
import { EventRegistration } from '../../../Data/Classes';
import { GUEST, ORGANISER, TEACHER, PHANTOM, REGISTERED, ASSIGNED, NOT_ASSIGNED, CANCELLED } from '../../../Data/Constants';
import { eventRegistrationTypeToString, registrationStateToString, postTypeToString } from '../../../Utils/Converters';

function EventRegistrationEditForm(props) {
    const [isProgress, setIsProgress] = useState(false);
    const [error, setError] = useState({});
    const [eventReg, setEventReg] = useState(props.eventReg);
    const [users, setUsers] = useState([]);
    const [searchValue, setSearchValue] = useState(props.eventReg.userName);
    const [usersVisible, setUsersVisible] = useState(false);

    useEffect(() => {
        Axios.get(`/admin/users?pageSize=5&page=0${searchValue && searchValue.length > 0 ? `&name=${searchValue}` : ''}`)
            .then(res => {
                setUsers(res.data);
            });
    }, [usersVisible, searchValue]);

    function onChange(e) {
        setEventReg({ ...eventReg, [e.target.name]: e.target.value });
    }

    function setUser(user) {
        setEventReg({ ...eventReg, userId: user.id, userName: user.name, userEmail: user.email });
    }

    /*function onDeleteClick(e) {
        if (window.confirm("Biztos, hogy törlöd a jelentkezést?\nA művelet nem visszavonható.")) {
            setIsProgress(true);
            Axios.delete(`/admin/events/${eventReg.eventId}/registrations/${eventReg.id}`)
                .then(res => {
                    setIsProgress(false);
                    toast.success(`A jelentkezés törölve.`);
                    window.history.back();
                }, err => {
                    setIsProgress(false);
                    toast.error("A jelentkezés törlése sikertelen volt.");
                });
        }
    }*/

    function onSubmit(e) {
        e.preventDefault();

        const isGuest = eventReg.type === GUEST || eventReg.type === TEACHER || eventReg.type === PHANTOM;
        const isOrganiser = eventReg.type === ORGANISER;

        setIsProgress(true);
        Axios.post(`/admin/events/${eventReg.eventId}/registrations/${eventReg.id}`,
            new EventRegistration(eventReg.id,
                Number(eventReg.type),
                Number(eventReg.state),
                eventReg.paidAmount,
                eventReg.adminRemark,
                eventReg.adminMessage,
                isGuest ? eventReg.guestName : null,
                isGuest ? eventReg.guestEmail : null,
                eventReg.steinCaption,
                eventReg.remark,
                isOrganiser ? Number(eventReg.post) : null,
                eventReg.userId,
                eventReg.eventId
            ))
            .then(response => {
                setIsProgress(false);
                toast.success('Jelentkezés elmentve.');
                window.history.back();
            }, err => {
                console.log(err);
                setIsProgress(false);
                setError(err.errors);
                toast.error(`A jelentkezés mentése sikertelen volt. ${err.errors[''] ? err.errors[''] : ''}`);
            });
    }

    if (isProgress)
        return <ProgressIndicator />;

    if (eventReg) {
        const organiserFieldsVisible = eventReg.type == ORGANISER;

        const organiserFields = <FormGroup row>
            <SelectFieldGroup className="col-md"
                field="post"
                onChange={onChange}
                label="Poszt"
                error={error.Post}
                value={eventReg.post}>
                {new Array(12).fill(0).map((value, index) => {
                    return <option value={index} key={index}>{postTypeToString(index)}</option>
                })}
            </SelectFieldGroup>
        </FormGroup>;

        const guestFieldsVisible = eventReg.type === GUEST || eventReg.type === TEACHER || eventReg.type === PHANTOM;

        const guestFields = <FormGroup row>
            <TextFieldGroup className="col-md"
                field="guestName"
                onChange={onChange}
                label="Vendég neve"
                error={error.GuestName}
                value={eventReg.guestName} />
            <TextFieldGroup className="col-md"
                field="guestEmail"
                onChange={onChange}
                label="Vendég email címe"
                error={error.GuestEmail}
                value={eventReg.guestEmail} />
        </FormGroup>;

        return (
            <Form onSubmit={onSubmit} id="eventRegistrationEditForm" >
                <FormGroup>
                    <FormGroup row>
                        <FormGroup className="col-md">
                            <Label for='userName'>Felhasználó</Label>
                            {!usersVisible && <Input onClick={() => { setUsersVisible(true); setSearchValue(eventReg.userName); }} invalid={error.UserId ? true : false} name='userName' value={`${eventReg.userName} (${eventReg.userEmail})`} readOnly />}
                            {usersVisible && <div className='dropDown rounded'>
                                <Input onChange={e => setSearchValue(e.target.value)} value={searchValue} name='userName' />
                                {users.map(u => <div className="item" key={uuid()} onClick={() => { setUser(u); setUsersVisible(false); }}>{u.name} ({u.email})</div>)}
                                <Button color="warning" onClick={() => setUsersVisible(false)}>Mégsem</Button>
                            </div>
                            }
                            {error.UserId && <FormFeedback>{error.UserId}</FormFeedback>}
                        </FormGroup>
                        <SelectFieldGroup className="col-md"
                            field="type"
                            onChange={onChange}
                            label="Jelentkezés típusa"
                            error={error.Type}
                            value={eventReg.type}>
                            {new Array(5).fill(0).map((value, index) => {
                                return <option value={index} key={index}>{eventRegistrationTypeToString(index)}</option>;
                            })}
                        </SelectFieldGroup>
                        <SelectFieldGroup className="col-md"
                            field="state"
                            onChange={onChange}
                            label="Jelentkezés állapota"
                            error={error.State}
                            value={eventReg.state}>
                            <option value={REGISTERED}>{registrationStateToString(REGISTERED)}</option>
                            <option value={CANCELLED}>{registrationStateToString(CANCELLED)}</option>
                            <option value={ASSIGNED}>{registrationStateToString(ASSIGNED)}</option>
                            <option value={NOT_ASSIGNED}>{registrationStateToString(NOT_ASSIGNED)}</option>
                        </SelectFieldGroup>
                    </FormGroup>
                    {guestFieldsVisible && guestFields}
                    {organiserFieldsVisible && organiserFields}
                    <FormGroup row>
                        <TextFieldGroup className="col-md"
                            field="paidAmount"
                            onChange={onChange}
                            label="Befizetett összeg"
                            type="number"
                            error={error.PaidAmount}
                            value={eventReg.paidAmount} />
                        <TextFieldGroup className="col-md"
                            field="remark"
                            onChange={onChange}
                            label="Megjegyzés"
                            error={error.Remark}
                            value={eventReg.remark} />
                        <TextFieldGroup className="col-md"
                            field="steinCaption"
                            onChange={onChange}
                            label="Korsó felirat"
                            error={error.SteinCaption}
                            value={eventReg.steinCaption} />
                    </FormGroup>
                    <FormGroup row>
                        <TextFieldGroup className="col-md"
                            field="adminRemark"
                            onChange={onChange}
                            label="Admin megjegyzés"
                            error={error.AdminRemark}
                            value={eventReg.adminRemark} />
                        <TextFieldGroup className="col-md"
                            field="adminMessage"
                            onChange={onChange}
                            label="Üzenet a jelentkezőnek"
                            error={error.AdminMessage}
                            value={eventReg.adminMessage} />
                    </FormGroup>
                </FormGroup>
                <Button color="primary" type="submit"><FontAwesomeIcon icon={faCheck} /> Mentés</Button>
                <Button color="primary" type="button" onClick={(e) => window.history.back()}><FontAwesomeIcon icon={faArrowLeft} /> Mégsem</Button>
                {/*<Button color="warning" type="button" onClick={onDeleteClick} className="float-right"><FontAwesomeIcon icon={faTrash} /> Törlés</Button>*/}
            </Form >
        );
    }

    return null;
}


export default EventRegistrationEditForm;
